const events = [
  {
    id: 1,
    sku: "FSE-001",
    name: "End Roll CTA - Business Card",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/end-roll-cta-business-card.gif",
    type: "postroll",
    personalizable: true,
    requirements: [
      "Buttons 1 to 3: Background Color, Text, Text Color, hover Color, Link",
      "Social Media Links",
    ],
    assets: [
      "Logo",
      "Background Image (png, jpg, gif, or solid color)",
      "Font File",
      "CSV with the user data (firstname, lastname, email, title, calendar_link, headshot_image)",
    ],
    internal: {
      id: 113091,
    },
  },
  {
    id: 2,
    sku: "FSE-002",
    name: "Generic Video Background Event",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/generic-video-background-event.gif",
    type: "postroll",
    personalizable: true,
    requirements: [
      "Button: Background Color, Text, Text Color, hover Color, Link",
    ],
    assets: [
      "Logo file (svg, png, or jpg)",
      "Background image (svg, png) OR background gif ",
      "Font File",
      "CSV with the user data (firstname, lastname, email, role, dept)",
    ],
    internal: {
      id: 113085,
    },
  },
  {
    id: 3,
    sku: "FSE-003",
    name: "3 Panel CTA Event",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/3-panel-cta-event.gif",
    type: "postroll",
    personalizable: true,
    requirements: [
      "Panels 1 to 3: Text, URL, Hex Background Color, and Font Color",
    ],
    assets: [
      "Panels 1 to 3: Icon (svg, png)",
      "Font File",
      "CSV with the user data (firstname, lastname, email, calendar_link)",
    ],
    internal: {
      id: 113083,
    },
  },
  {
    id: 4,
    sku: "FSE-004",
    name: "Generic Full Screen Button Event",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/generic-full-screen-button-event.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "Header Text",
      "Button: Background Color, hover Background Color, Text, Text Color, Link",
    ],
    assets: [
      "Background Image (png, jpg, or gif) or solid color hex code",
      "Font File",
    ],
    internal: {
      id: 113094,
    },
  },
  {
    id: 5,
    sku: "FSE-005",
    name: "Social Sharing Post Roll",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/social-sharing-post-roll.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "CTA Header Text, Text Color",
      "Social Links",
      "Buttons 1 to 3: Background Color, hover Background Color",
    ],
    assets: [
      "Background Image (png, jpg, or gif) or solid color hex code",
      "Font File",
    ],
    internal: {
      id: 113107,
    },
  },
  {
    id: 6,
    sku: "FSE-006",
    name: "2 Panel CTA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/2-panel-cta.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "Panel 1: Background Color, Button Color, Button Text, Button Link, Text Color ",
      "Panel 2: Background Color, Button Color, Button Text, Button Link, Text Color ",
    ],
    assets: ["Font File"],
    internal: {
      id: 113088,
    },
  },
  {
    id: 7,
    sku: "FSE-007",
    name: "Support CTA 2 cards",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/support-cta-2-cards.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "Card 1: Card Text, Link, Background Color, Text Color",
      "Card 2: Card Text, Link, Background Color, Text Color",
    ],
    assets: ["Background Image (svg, png, or gif)", "Font File"],
    internal: {
      id: 113089,
    },
  },
  {
    id: 8,
    sku: "FSE-008",
    name: "Support CTA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/support-cta.gif",
    type: "postroll",
    personalizable: false,
    requirements: ["Card 1: Card Text, Link, Background Color, Text Color"],
    assets: ["Background Image (svg, png, or gif)", "Font File"],
    internal: {
      id: 113090,
    },
  },
  {
    id: 9,
    sku: "FSE-009",
    name: "Generic Download CTA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/generic-download-cta.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "Title of CTA Text, Text Color, Banner Background Color",
      "CTA Body Text, Text Color, Body Background Color",
      "Button: Background Color, hover Background Color, Text, Text Color, Link",
    ],
    assets: ["Body Image (png, jpg, or gif)", "Font File"],
    internal: {
      id: 113095,
    },
  },
  {
    id: 10,
    sku: "FSE-010",
    name: "3-Panel CTA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/3-panel-cta.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "Buttons 1 to 3: Background Color, hover Background Color, Text, Text Color, Link",
      "Panel 2: Background Color, Button Color, Button Text, Button Link, Text Color ",
    ],
    assets: [
      "Background Image (png, jpg, or gif) or solid color hex code",
      "Panels 1 to 3: Background Image (png, jpg, or gif) or solid color hex code",
      "Font File",
    ],
    internal: {
      id: 113106,
    },
  },
  {
    id: 11,
    sku: "AE-011",
    name: "Pulsing Button CTA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/pulsing-button-cta.gif",
    type: "annotation",
    personalizable: false,
    requirements: [
      "Buttons 1 to 4: Background Color, hover Background Color, Text, Text Color, Link",
    ],
    assets: ["Font File"],
    internal: {
      id: 113109,
    },
  },
  {
    id: 12,
    sku: "FSE-012",
    name: "5-Panel Responsive CYOA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/5-panel-responsive-cyoa.gif",
    type: "postroll",
    personalizable: false,
    requirements: ["Panels 1 to 5: Background Color, Text, Text, Color, Link"],
    assets: ["Font File"],
    internal: {
      id: 113097,
    },
  },
  {
    id: 13,
    sku: "FSE-013",
    name: "4-Panel Responsive CYOA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/4-panel-responsive-cyoa.gif",
    type: "postroll",
    personalizable: false,
    requirements: ["Panels 1 to 4: Background Color, Text, Text, Color, Link"],
    assets: ["Font File"],
    internal: {
      id: 113098,
    },
  },
  {
    id: 14,
    sku: "FSE-014",
    name: "5 Option Horizontal Choose Your Own Adventure",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/5-option-horizontal-cyoa.png",
    type: "postroll",
    personalizable: false,
    requirements: [
      "CTA Header Text, Text Color",
      "CTA Subheader Text, Text Color",
      "Panels 1 to 5: Background Color, Text, Text, Color, Link",
    ],
    assets: ["Font File"],
    internal: {
      id: 113099,
    },
  },
  {
    id: 15,
    sku: "FSE-015",
    name: "4 Option Horizontal Choose Your Own Adventure",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/4-option-horizontal-cyoa.png",
    type: "postroll",
    personalizable: false,
    requirements: [
      "CTA Header Text, Text Color",
      "CTA Subheader Text, Text Color",
      "Panels 1 to 4: Background Color, Text, Text, Color, Link",
    ],
    assets: ["Font File"],
    internal: {
      id: 113100,
    },
  },
  {
    id: 16,
    sku: "FSE-016",
    name: "CYOA 6 Option Thumbnails",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/cyoa-6-option-thumbnails.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "Panels 1 to 6: Link and Text",
      "CTA Header Text",
      "Text Color",
    ],
    assets: ["Panels 1 to 6: Image", "Font File"],
    internal: {
      id: 113084,
    },
  },
  {
    id: 17,
    sku: "FSE-017",
    name: "3 Options CYAO with title & replay",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/3-option-cyoa-with-title-and-replay.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "CTA Header Text, Text Color",
      "CTA Subheader Text, Text Color",
      "Panels 1 to 3: Button Color, Button Text, Button Link, Text Color ",
    ],
    assets: [
      "Background Image (png, jpg, or gif) or solid color hex code",
      "Font File",
    ],
    internal: {
      id: 113101,
    },
  },
  {
    id: 18,
    sku: "FSE-018",
    name: "2 Options CYAO with title & replay",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/2-options-cyoa-with-title-and-replay.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "CTA Header Text, Text Color",
      "CTA Subheader Text, Text Color",
      "Panel 1: Button Color, Button Text, Button Link, Text Color ",
      "Panel 2: Button Color, Button Text, Button Link, Text Color ",
    ],
    assets: [
      "Background Image (png, jpg, or gif) or solid color hex code",
      "Font File",
    ],
    internal: {
      id: 113102,
    },
  },
  {
    id: 19,
    sku: "FSE-019",
    name: "4 Options CYAO with title & replay",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/4-options-cyao-with-title-and-replay.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "CTA Header Text, Text Color",
      "CTA Subheader Text, Text Color",
      "Panel 1: Button Color, Button Text, Button Link, Text Color ",
      "Panel 2: Button Color, Button Text, Button Link, Text Color ",
    ],
    assets: [
      "Background Image (png, jpg, or gif) or solid color hex code",
      "Font File",
    ],
    internal: {
      id: 113103,
    },
  },
  {
    id: 20,
    sku: "FSE-020",
    name: "4 Option Choose Your Own Adventure",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/4-option-choose-your-own-adventure.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "Options 1 to 4: Background Color",
      "Buttons 1 to 4: Background Color, hover Background Color, Text, Text Color, Link",
    ],
    assets: ["Font File"],
    internal: {
      id: 113108,
    },
  },
  {
    id: 21,
    sku: "FSE-021",
    name: "Thumbs Up/Down CTA",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/thumbs-up-down-cta.gif",
    type: "postroll",
    personalizable: false,
    requirements: [
      "CTA Header Text, Text Color",
      "Hex Colors for Thumb Icons, and hover Colors",
    ],
    assets: [
      "Background Image (png, jpg, or gif) or solid color hex code",
      "Font File",
    ],
    internal: {
      id: 113105,
    },
  },
  {
    id: 22,
    sku: "AE-022",
    name: "Annotation - Navigation Bar for skipping to Timecodes or Chapters",
    description: "",
    image:
      "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/events/annotation-navigation-bar-for-skipping-to-timecodes-or-chapters.gif",
    type: "annotation",
    personalizable: false,
    requirements: [
      "List of Panels",
      "Panel Time Stamps",
      "Panel Background color/ hover color",
      "Panel Text color/ hover Text color",
    ],
    assets: ["Font File"],
    internal: {
      id: 113087,
    },
  },
];

export default events;
